import 'components/hands/css/ActionCell.css';

export const ActionCell = ({ actions, isCurrentlyActing, actionRequirements }) => {
  const amountToCall = actionRequirements?.amountToCall ?? 0;
  const canCheck = actionRequirements?.canCheck ?? false;
  const minRaise = actionRequirements?.minRaise ?? 0;

  return (
    <div className={`action-cell ${isCurrentlyActing ? 'action-cell-active' : ''}`}>
      {isCurrentlyActing && (
        <div className="action-indicator">
          {canCheck ? (
            <div className="action-indicator-check">
              <div className="action-indicator-icon">
                <span className="action-indicator-dot action-indicator-dot-green"></span>
                Can check
              </div>
            </div>
          ) : (
            <div className="action-indicator-call">
              <div className="action-indicator-icon">
                <span className="action-indicator-dot action-indicator-dot-blue"></span>
                ${amountToCall} to call
              </div>
            </div>
          )}
          {minRaise > 0 && (
            <div className="action-indicator-raise">
              <div className="action-indicator-icon">
                <span className="action-indicator-dot action-indicator-dot-purple"></span>
                Min raise ${minRaise}
              </div>
            </div>
          )}
        </div>
      )}
      
      {actions && actions.length > 0 ? (
        <div className="actions-list">
          {actions.map((action, index) => (
            <div 
              key={index} 
              className={`action-item ${index > 0 ? 'action-item-border' : ''}`}
            >
              <div className="action-name">
                {action.action}
              </div>
              {action.amount && (
                <div className="action-amount">
                  ${action.amount}
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        !isCurrentlyActing && (
          <div className="action-empty">—</div>
        )
      )}
    </div>
  );
};
